const type = Object.freeze({
  ADMINISTRADOR_PORTAL_SALFA: 'ADMINISTRADOR_PORTAL_SALFA',
  ADMINISTRADOR_DE_CONTRATO: 'ADMINISTRADOR_DE_CONTRATO',
  GESTOR_DE_FLOTA_DECISOR: 'GESTOR_DE_FLOTA/DECISOR',
  ENCARGADO_DE_FLOTA_SECCION: 'ENCARGADO_DE_FLOTA/SECCION',
  SUPERVISOR: 'SUPERVISOR',
});
export default type;
